import { render, staticRenderFns } from "./SplitParcelsModal.vue?vue&type=template&id=1fae1808&scoped=true"
import script from "./SplitParcelsModal.vue?vue&type=script&lang=js"
export * from "./SplitParcelsModal.vue?vue&type=script&lang=js"
import style0 from "./SplitParcelsModal.vue?vue&type=style&index=0&id=1fae1808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fae1808",
  null
  
)

export default component.exports